class Parallax
{
	static parallaxOpacitOn()
	{
        const distancia = 100;

        let y = ((100 * window.scrollY) / 80) / distancia;

        if( y <= 1 )
        {
			return y;
        }
        else
        {
			return 1;
        }
	}

	static parallaxOpacitOff()
	{
        const distancia = 100;

        let y = ((100 * window.scrollY) / 100) / distancia;
        let off  = 1 - y;
		
        if( off > 0 )
        {
            return off;
        }
        else if( off > 1 )
        {
			return 1;
        }
        else
        {
			return 0;
        }
	}

	scrollHeader(scroll)
	{
		let opacityOn = Parallax.parallaxOpacitOn();
        let opacityOff = Parallax.parallaxOpacitOff();

		$('#mainHeader:not(.internas) #backgroundBar').css({ 'opacity': opacityOn });
		$('#mainHeader:not(.internas) #gradiente').css({ 'opacity': opacityOff });

		if (opacityOff <= 0)
		{
			$('#mainHeader:not(.internas) #gradiente').css({'display':'none'});
		}
		else
		{
			$('#mainHeader:not(.internas) #gradiente').css({ 'display': 'block' });
		}
	}

	init()
	{
		let self = this;

		self.scrollHeader($(window).scrollTop());

		$(window).scroll(function (event)
		{
			self.scrollHeader($(window).scrollTop());
		});

		window.addEventListener("resize", function()
		{
			self.scrollHeader($(window).scrollTop());
		});
	}
}

export default Parallax;